import type { Variants, Transition } from "framer-motion";

/* ── Shared transitions ── */
export const smoothSpring: Transition = {
  type: "spring",
  stiffness: 80,
  damping: 20,
  mass: 0.8,
};

export const gentleSpring: Transition = {
  type: "spring",
  stiffness: 50,
  damping: 18,
  mass: 1,
};

export const viscousEase: Transition = {
  duration: 1.4,
  ease: [0.22, 1, 0.36, 1],
};

/* ── Fade up ── */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 40, filter: "blur(4px)" },
  visible: { opacity: 1, y: 0, filter: "blur(0px)" },
};

/* ── Fade in from sides ── */
export const fadeLeft: Variants = {
  hidden: { opacity: 0, x: -60, filter: "blur(4px)" },
  visible: { opacity: 1, x: 0, filter: "blur(0px)" },
};

export const fadeRight: Variants = {
  hidden: { opacity: 0, x: 60, filter: "blur(4px)" },
  visible: { opacity: 1, x: 0, filter: "blur(0px)" },
};

/* ── Scale up ── */
export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.88, filter: "blur(6px)" },
  visible: { opacity: 1, scale: 1, filter: "blur(0px)" },
};

/* ── Stagger container ── */
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

export const staggerContainerFast: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

/* ── Word split (for headlines) ── */
export const wordReveal: Variants = {
  hidden: { opacity: 0, y: 20, rotateX: -40 },
  visible: { opacity: 1, y: 0, rotateX: 0 },
};

/* ── Card 3D tilt helper (CSS perspective applied on parent) ── */
export const card3D: Variants = {
  hidden: { opacity: 0, y: 30, rotateY: -4, scale: 0.95 },
  visible: { opacity: 1, y: 0, rotateY: 0, scale: 1 },
};

/* ── Glow pulse keyframes (use with animate prop) ── */
export const glowPulse = {
  boxShadow: [
    "0 0 0px hsl(217 91% 60% / 0)",
    "0 0 20px hsl(217 91% 60% / 0.4)",
    "0 0 0px hsl(217 91% 60% / 0)",
  ],
};

/* ── Counter animation helper ── */
export function useCountUp(
  target: number,
  duration = 1.5,
  isVisible: boolean
) {
  // This is a simple hook signature — actual implementation uses framer-motion's useMotionValue
  return { target, duration, isVisible };
}

/* ── Viewport defaults ── */
export const viewportOnce = { once: true, margin: "-60px 0px" as const };
export const viewportOnceEarly = { once: true, margin: "-20px 0px" as const };
